import { saveAs } from 'file-saver';

import api from '@/api/learners';
import vpaHistoryColumns from './vpa-history-columns';

const namespaced = true;

export const actions = {
  FETCH_VPA_HISTORY: ({ commit }, { learnerId }) => {
    return new Promise(resolve => {
      api
        .fetchVpaHistory({ learnerId })
        .then(response => {
          response.results.forEach((r, index) => {
            r.vpa_number = response.count - index;
          });
          return response;
        })
        .then(response => {
          commit('SET_HISTORY', { history: response.results });
          commit('SET_HISTORY_COUNT', { count: response.count });
          resolve(response);
        });
    });
  },

  DOWNLOAD_VPA_HISTORY: (ctx, { learnerId, format, filename }) => {
    const toBlob = response => response.blob();

    return new Promise(resolve => {
      api
        .fetchVpaHistory({ learnerId, format, callback: toBlob })
        .then(responseBlob => {
          saveAs(responseBlob, filename);
        })
        .then(resolve);
    });
  },
};

export const mutations = {
  SET_HISTORY(state, { history }) {
    state.history = history;
  },
  SET_HISTORY_COUNT(state, { count }) {
    state.count = count;
  },
};

export const getters = {
  lastVpa: state => {
    if (state.count === 0) {
      return null;
    }
    return state.history[0];
  },
};

const state = {
  history: [],
  count: 0,
  columns: vpaHistoryColumns,
};

export default {
  namespaced,
  actions,
  mutations,
  getters,
  state,
};
